import React from 'react';
import ReactDOM from 'react-dom';

import FormItemConst from '../../formItem/FormItemConst';
import {DiaLogMapEditorsStore} from '../../stores/CommandStore';
import DialogValue from './remote/DialogValue';
import GOT from '../../utils/GOT';
import GOTUtil from '../../utils/GOTUtil';
import Warn from '../../utils/Warn';
import FormItemDecimalResolver from  '../../formItem/resolver/FormItemDecimalResolver';
import FormItemDecimalDisplay from '../../formItem/display/FormItemDecimalDisplay';

export default class DialogFieldDecimalEditor extends React.Component
{
	constructor(props) {
		super(props);		
		this.state = {data:this.props.data};
		this.decimalProperties = {};
		//allowNegative:true,numOfDecimals:2,roundOff:"HalfUp",showDecimals:2,showZero:true,thousandSeperator:false
		if(this.props.data.editorType == "TypeDecimal")
		{
			let entityId = this.props.data.entityId;
			if(entityId)
			{
				let decimalDataType = GOT.getDataType(entityId);
				if(decimalDataType)
				{
					this.decimalProperties.allowNegative = true;//GOTUtil.getPropertyValue(decimalDataType,"AllowNegative");
					this.decimalProperties.numOfDecimals = GOTUtil.getPropertyValueStepByStep(decimalDataType,decimalDataType,"NumOfDecimals","",false,false);//GOTUtil.getPropertyValue(decimalDataType,"NumOfDecimals");
					this.decimalProperties.roundOff = GOTUtil.getPropertyValueStepByStep(decimalDataType,decimalDataType,"RoundOff","",false,false);//GOTUtil.getPropertyValue(decimalDataType,"RoundOff");
					this.decimalProperties.showDecimals = GOTUtil.getPropertyValueStepByStep(decimalDataType,decimalDataType,"DisplayDecimals","",false,false);// GOTUtil.getPropertyValue(decimalDataType,"DisplayDecimals")
															//|| GOTUtil.getPropertyValue(decimalDataType,"ShowDecimals");
					this.decimalProperties.showZero = GOTUtil.getPropertyValueStepByStep(decimalDataType,decimalDataType,"ShowZero","",false,false);//GOTUtil.getPropertyValue(decimalDataType,"ShowZero");
					this.decimalProperties.thousandSeperator = GOTUtil.getPropertyValueStepByStep(decimalDataType,decimalDataType,"ThousandSeperator","",false,false);//GOTUtil.getPropertyValue(decimalDataType,"ThousandSeperator");
					this.decimalProperties.fromDataType = true;
				}
			}
			
		}
		this.unsubscribeDiaLogMapEditorsStore = DiaLogMapEditorsStore.listen(this.onDiaLogMapEditors.bind(this));
	}

	onDiaLogMapEditors(dialogId,result)
	{
		if(this.props.dialogId == dialogId)
		{
			let dv = new DialogValue();
			dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
			dv.value = this.record?this.record+"":$(this.inputField).val();dv.entityId = this.props.data.entityId;
			//alert("DialogFieldStringEditor侦听");
			result[this.props.data.id] = dv;
		}
	}

	onKeyPressHandler(event)
	{
		return (/[\d|\.|\-]/.test(String.fromCharCode(event.charCode)));
	}

	inputFieldBlur()
	{
		let value = $(this.inputField).val();
		if(!this.decimalProperties.fromDataType)
		{
			var regu = /^(\-|\+)?\d+(\.\d+)?$/;
			if(!regu.test(value))
			{
				$(this.inputField).val(this.record?this.record:"0");
			}
			return;
		}
		
		value = FormItemDecimalResolver.getResult(value,false,this.decimalProperties.allowNegative,this.decimalProperties.numOfDecimals,this.decimalProperties.roundOff);
		if(value && value.indexOf("false:") == 0)
		{
			Warn.show({text:value.substr(6)});
			return;
		}
		this.record = value;
		this.setDisplay();
	}

	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			value = this.record;
		}

		if(value == null)
			value = "";
		if(value != "")
		{
			let parms = {};
			if(this.decimalProperties.displayStyle == "%")
				parms.percent = true;
			value = FormItemDecimalDisplay.getDisplayText(value,this.decimalProperties.showZero,this.decimalProperties.showDecimals,this.decimalProperties.thousandSeperator,parms);
		}

		$(this.inputField).val(value);
	}

	getInputDom(_width)
	{
		let allowEdit = this.state.data.allowEdit;
		let _id = this.state.data.id;
		let _defaultValue = this.state.data.defaultValue;
		if(!_defaultValue)
			_defaultValue = "";
		if(allowEdit)
		{
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,fontSize:"12px"}
			
			return	<input spellCheck="false" ref={node => this.inputField = node} type="number" onBlur={this.inputFieldBlur.bind(this)} 
			        	   className="form-control" style={_style} defaultValue={_defaultValue} onKeyPress = {this.onKeyPressHandler.bind(this)}/>;
		}
		else
		{	
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px"};		
			
			return	<input spellCheck="false" ref={node => this.inputField = node} type="text" readOnly="readonly"
			        	   className="form-control" style={_style} defaultValue={_defaultValue} onKeyPress = {this.onKeyPressHandler.bind(this)}/>;
		}
	}

	render()
	{
		let displayLength=this.state.data.displayLength;
		if(displayLength == 0)displayLength = FormItemConst.DISPLAYLENGTH_DATE_DEFAULT;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';

		let notNull=this.state.data.notNull;
		let _label = this.state.data.label;
		let _id = this.state.data.id;

		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';
		
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		
		let inputdom = this.getInputDom(_width);
		let labelStyle = {paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		return(

			<div id={"EditorDialog"+_id} className='editorGroup' style={editorStyle}>
				<label htmlFor={"inputDialog"+_id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle}>
					{_label}
				</label>
				<i className='fa fa-snowflake-o' style={_notNullStyle}></i>
				<div style={{position:"relative"}}>
					{inputdom}
			    </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldDecimalEditor.js